import { AxiosRequestConfig } from 'axios';

export const API_PREFIX = '%PREFIX%';

export const FILE_UPLOAD_HEADERS: Partial<AxiosRequestConfig> = { headers: { 'Content-Type': 'multipart/form-data' } };
